import React, { useEffect, useState } from "react";
import { imgURL } from "../../apiConfig";
import { Button, Table, Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import axios from "axios";

const AdminTPContent = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // integrating post method
  const formdata = new FormData();
  const [PSImage1, setPSImage1] = useState("");
  const [HTImage2, setHTImage2] = useState("");
  const [PSText1, setPSText1] = useState("");
  const [CImage3, setCImage3] = useState("");
  const [CText3, setCText3] = useState("");
  const [HTText2, setHTText2] = useState("");

  const AdddTandP = async () => {
    formdata.set("PSImage1", PSImage1);
    formdata.set("HTImage2", HTImage2);
    formdata.set("PSText1", PSText1);
    formdata.set("CImage3", CImage3);
    formdata.set("CText3", CText3);
    formdata.set("HTText2", HTText2);

    try {
      const config = {
        url: "/user/TandP",
        method: "post",
        baseURL: "/api",
        headers: { "content-type": "multipart/form-data" },
        data: formdata,
      };
      let res = await axios(config);
      if (res.status === 200) {
        alert(res.data.success);
        getTandP();
        handleClose();
      }
    } catch (error) {
      console.log(error);
      alert(error.response.data.msg);
    }
  };
  //integrating get  method
  const [AddTandP, setAddTandP] = useState([]);
  const getTandP = async () => {
    try {
      let res = await axios.get("/api/user/getTandP");
      if (res.status === 200) {
        setAddTandP(res.data.getTandP);
      }
    } catch (error) {
      console.log(error);
    }
  };
  //delete method
  const [Data, setData] = useState("");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = (item) => {
    setShow2(true);
    setData(item);
  };
  const DeleteTandP = async () => {
    try {
      const config = {
        url: "user/DeleteTandP/" + Data,
        method: "delete",
        baseURL: "/api/",
        header: { "content-type": "application/json" },
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert("successfully delete");
          getTandP();
          handleClose2();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.msg);
    }
  };
  //update method
  const [Data1, setData1] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = (item) => {
    setShow1(true);
    setData1(item);
  };

  const editTandP = async (e) => {
    e.preventDefault();
    // if (!PSImage1) {
    //   alert("Select the image");
    // } else {
    formdata.set("PSImage1", PSImage1);
    formdata.set("HTImage2", HTImage2);
    formdata.set("PSText1", PSText1);
    formdata.set("CImage3", CImage3);
    formdata.set("CText3", CText3);
    formdata.set("HTText2", HTText2);
    formdata.set("id", Data1?._id);
    try {
      const config = {
        url: "/user/editTandP",
        method: "put",
        baseURL: "/api",
        header: { "content-type": "multipart/form-data" },
        data: formdata,
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert("successfully Update");
          handleClose1();
          getTandP();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
    }
    // }
  };
  useEffect(() => {
    getTandP();
  }, []);
  console.log(AddTandP);
  return (
    <>

      <div className="add-gr">
        <div className="container">
          <div className="ad-b mt-4 mb-4">
            {AddTandP.length !== 0 ? (
              <></>
            ) : (
              <>
                <button className="btn btn-success" onClick={handleShow}>
                  Add Play School/School/College Content
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mo-gra mt-5">
          <Table striped bordered hover style={{ textAlign: "center" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Play School Image</th>
                <th>Play School Text</th>

                <th>School Image</th>
                <th>School Text</th>

                <th>College Image</th>
                <th>College Text</th>

                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {AddTandP?.map((item, i) => {
                return (
                  <tr>
                    <td>{++i}</td>
                    <td>
                      <Image
                        src={imgURL(`/TandP/${item?.PSImage1}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>

                    <td style={{ paddingTop: "20px" }}>
                      <p className="card_text_p" style={{ height: "100px", overflow: "hidden auto" }}>
                        {item?.PSText1}
                      </p>{" "}
                    </td>

                    <td>
                      <Image
                        src={imgURL(`/TandP/${item?.HTImage2}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>
                    <td style={{ paddingTop: "20px" }}>
                      <p className="card_text_p" style={{ height: "100px", overflow: "hidden auto" }}>
                        {item?.HTText2}
                      </p>
                    </td>

                    <td style={{ paddingTop: "20px" }}>
                      {" "}
                      <Image
                        src={imgURL(`/TandP/${item?.CImage3}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>
                    <td style={{ paddingTop: "20px" }}>
                      <p className="card_text_p" style={{ height: "100px", overflow: "hidden auto" }}>
                        {item?.CText3}
                      </p>
                    </td>

                    <td>
                      <div className="ad-b ">
                        <span>
                          <i
                            class="fas fa-edit"
                            style={{
                              fontSize: "20px",
                              color: "green",
                              paddingTop: "20px",
                            }}
                            onClick={() => handleShow1(item)}
                            title="edit"
                          ></i>
                        </span>
                      </div>
                    </td>
                    <td>
                      <i
                        class="fa fa-trash"
                        aria-hidden="true"
                        style={{
                          color: "red",
                          fontSize: "20px",
                          paddingTop: "20px",
                        }}
                        onClick={() => handleShow2(item?._id)}
                        title="delete"
                      ></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a695" }}>
            {" "}
            Add Play School/School/College Content
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="floatingInput" label="Play School Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setPSImage1(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel
            controlId="floatingInput"
            label="Enter TextPlay School"
          >
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setPSText1(e.target.value)}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" School Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setHTImage2(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel
            controlId="floatingInput"
            label="Enter text for School"
          >
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setHTText2(e.target.value)}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" College Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setCImage3(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingInput" label="Enter Text College">
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setCText3(e.target.value)}
            />
          </FloatingLabel>{" "}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#00a695", border: "none" }}
            onClick={AdddTandP}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a695" }}>
            {" "}
            Update Play School/School/College Content
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="floatingInput" label="Play School Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setPSImage1(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel
            controlId="floatingInput"
            label="Enter Text Play School"
          >
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setPSText1(e.target.value)}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" School Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setHTImage2(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel
            controlId="floatingInput"
            label="Enter text for School"
          >
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setCImage3(e.target.value)}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" College Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setCImage3(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingInput" label="Enter Text College">
            <Form.Control
              type="text"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setCText3(e.target.value)}
            />
          </FloatingLabel>{" "}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#00a695", border: "none" }}
            onClick={editTandP}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 style={{ color: "#c0392b" }}>Do You Really Want To Delete...</h3>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Close
          </Button>
          <Button variant="primary" onClick={DeleteTandP}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminTPContent;
